import axios from 'axios';

import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
} from 'Vulture/ENV.js';

const saveData = async function (body = {}) {
	const session = getSession();

	let url = `${broncoURL}/w/edit`;
	let headers = {
		'X-Auth-Session': session.session,
	};

	try {
		let res = await axios.post(url, body, { headers });

		return res.data;
	} catch (err) {
		console.error(err);
		// Surface the server's reason (e.g. a 403 "missing permission for write on
		// account") instead of returning undefined — callers must be able to tell
		// failure from success, or permission errors read as silent no-ops.
		// NOTE: failure is now TRUTHY — check `res?.error`, never `if (res)`.
		return {
			error: err.response?.data?.error || 'A network error has occured.',
			status: err.response?.status,
		};
	}
};

const sanitizeData = (input) => {
	// Convert the input to a string for validation
	const inputAsString = String(input);

	// Trim the input
	const trimmedInput = inputAsString.trim();

	// Define an allowlist of special characters
	const allowedSpecialChars = '@.\\-_: ';

	// Use a regex to match only allowed characters
	const regex = new RegExp(`^[a-zA-Z0-9${allowedSpecialChars}]*$`);

	// Test the input against the regex
	if (regex.test(trimmedInput)) {
	  // Return the original input value if it passes the test
	  return input;
	}

	// Return an empty string if input is null or empty
	return null;
};

export {
	saveData,
	sanitizeData,
};